import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { resetFontSize, setFontSize } from "../../../store/slices/fontManagerSlice";
import styles from "./FontSizeControl.module.css";

const FontSizeControl = ({ defaultFontSize, minFontSize, maxFontSize, fontSizeKey,label }) => {
    const STEP = 1;
    const dispatch = useDispatch();

    const fontSize =
        useSelector((state) => state.fontManager.fontSizes[fontSizeKey]) ||
        parseInt(localStorage.getItem(fontSizeKey), 10) ||
        defaultFontSize;

    useEffect(() => {
        localStorage.setItem(fontSizeKey, fontSize);
    }, [fontSize, fontSizeKey]);

    const handleIncrease = () => {
        if (fontSize < maxFontSize) {
            dispatch(setFontSize({ key: fontSizeKey, size: fontSize + STEP }));
        }
    };

    const handleDecrease = () => {
        if (fontSize > minFontSize) {
            dispatch(setFontSize({ key: fontSizeKey, size: fontSize - STEP }));
        }
    };

    const handleReset = () => {
        dispatch(resetFontSize({ key: fontSizeKey, defaultSize: defaultFontSize }));
        localStorage.setItem(fontSizeKey, defaultFontSize);
    };

    return (
        <div className={styles.container}>
            <div className={styles.title}>
                {label} font size
            </div>
            <button
                onClick={handleDecrease}
                className={styles.button}
                disabled={fontSize <= minFontSize}
            >
                -
            </button>

            <span className={styles.label}>{fontSize}</span>

            <button
                onClick={handleIncrease}
                className={styles.button}
                disabled={fontSize >= maxFontSize}
            >
                +
            </button>

            <button onClick={handleReset} className={styles.resetButton}>
                Reset
            </button>
        </div>
    );
};

export default FontSizeControl;
